import React, {ReactElement} from 'react';
import {ButtonProps, MenuItem, MenuItemProps, ButtonBase} from '@mui/material'
import {
    Link as RouterLink,
    LinkProps as RouterLinkProps,
} from 'react-router-dom';

interface MenuItemLinkProps extends MenuItemProps {
    primary?: string;
    to?: string;
    target?: string;
}

const Link = React.forwardRef<
    HTMLAnchorElement,
    RouterLinkProps
    //Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] }
>(function Link(
    itemProps,
    ref,
) {
    return <RouterLink ref={ref} {...itemProps} data-matched={'link-element'} role={undefined} />;
});

function ListItemLink(props: MenuItemLinkProps & ButtonProps) {
    const { primary, to } = props;

    return (
        <li>
            {!!to ? (
                <MenuItem component={Link} to={to} target={props?.target} sx={props?.sx || undefined}>
                    {props.children ? props.children : (
                        <>
                            <div>{primary}</div>
                        </>
                    )}
                </MenuItem>
            ) : (
                <MenuItem component={ButtonBase} {...props} sx={{ width: '100%' }} />
            )}
        </li>
    );
}

export default ListItemLink;